import { createFileRoute } from "@tanstack/react-router";
import LegalPage from "@/components/LegalPage";
import { buildHead, breadcrumbLD } from "@/content/seo";

const TITLE = "Cookie Policy · Morningstar Yacht · Vilamoura";
const DESC = "How Morningstar Yacht (Vilamoura Dreams Cruises) uses cookies — necessary, functional, analytics and advertising cookies, and how to manage your consent.";
const PATH = "/cookie-policy";

export const Route = createFileRoute("/cookie-policy")({
  component: () => (
    <LegalPage
      lang="en"
      title="Cookie Policy"
      updated="May 2026"
      homeHref="/"
      backLabel="Back to home"
      intro='We use cookies to enhance your browsing experience, analyze site traffic and personalize content. By clicking "Accept", you consent to our use of cookies. You can change your preferences at any time using the cookie controls in your browser.'
      sections={[
        {
          heading: "What are cookies?",
          body: [
            "Cookies are small text files stored on your device when you visit a website. They help the site remember your preferences and improve your experience.",
          ],
        },
        {
          heading: "Necessary cookies",
          body: [
            "Essential cookies required for the site to function properly — for example, storing your cookie consent choice and your language preference. These cannot be disabled.",
          ],
        },
        {
          heading: "Functional cookies",
          body: ["Cookies that enhance functionality by storing your preferences."],
        },
        {
          heading: "Analytics cookies",
          body: [
            "Cookies that collect anonymous data on how visitors use the website (for example, Google Analytics) so we can improve content and navigation.",
          ],
        },
        {
          heading: "Advertising cookies",
          body: ["Cookies used to measure the efficiency of advertising campaigns across websites."],
        },
        {
          heading: "Managing your consent",
          body: [
            "You can accept, reject or customize cookie categories at any time using the cookie banner on the site, or directly in your browser settings.",
          ],
        },
        {
          heading: "Contact",
          body: [
            'For any question about this policy, contact us at <a class="underline hover:text-gold" href="mailto:info@vilamouradreamscruises.com">info@vilamouradreamscruises.com</a>.',
          ],
        },
      ]}
    />
  ),
  head: () =>
    buildHead({
      lang: "en",
      path: PATH,
      title: TITLE,
      description: DESC,
      altPath: { en: PATH, pt: "/pt/politica-de-cookies" },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Home", path: "/" },
              { name: "Cookie Policy", path: PATH },
            ]),
          ),
        },
      ],
    }),
});